import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { Button } from '../ui/Button'
import { LocalizedLink } from '../LocalizedLink'

export function ContactCTA() {
  const { t } = useTranslation()

  return (
    <Section variant="primary" spacing="lg" className="border-b-4 border-dark">
      <Container>
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            {t('cta.subtitle')}
          </p>
          <LocalizedLink to="contacts">
            <Button variant="primary" size="lg">
              {t('buttons.contactUs')}
            </Button>
          </LocalizedLink>
        </div>
      </Container>
    </Section>
  )
}
